export default "__VITE_ASSET__e93ff4f3__"